export default __webpack_public_path__ + "static/media/image.yolo-ways.883fbe29.png";